import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup } from '@angular/forms';
import moment from 'moment';
import { RequestViewService } from '../../../../core/services/request-view.service';
import { DatePickerCustomHeaderComponent } from '../../date-picker-custom-header/date-picker-custom-header.component';

@Component({
    selector: 'app-date-range-input',
    templateUrl: './date-range-input.component.html',
    styleUrls: ['./date-range-input.component.css']
})
export class DateRangeInputComponent implements OnChanges {
    @Input() startDateInput;
    @Input() endDateInput;
    @Input() serviceInputsForm: FormGroup;
    @Input() readOnly;
    @Output() onChange = new EventEmitter<any>();
    invalidEndDateError = false;
    customHeader = DatePickerCustomHeaderComponent;
    form;

    @Input() maxDate: Date = new Date();

    constructor(private requestViewService: RequestViewService) {}

    ngOnChanges(changes: SimpleChanges): void {
        this.invalidEndDateError = false;
        this.form = this.serviceInputsForm.get('requiredFormGroup');
    }

    onDatepickerClose(startDateControl, endDateControl) {
        const startDateValue = this.form.get(startDateControl).value;
        const endDateValue = this.form.get(endDateControl).value;

        if (!endDateValue && startDateValue) {
            this.invalidEndDateError = true;
        } else if (startDateValue && endDateValue) {
            const format = 'YYYY-MM-DD';
            this.form.get(startDateControl).setValue(moment(startDateValue).format(format));
            this.form.get(endDateControl).setValue(moment(endDateValue).format(format));
            this.invalidEndDateError = false;
        }

        this.requestViewService.dateRangeChanged.next(true);
        this.onChange.emit(true);
    }

    onClickOpenPicker(picker) {
        if (!this.readOnly) {
            picker.open();
        }
    }
}
